import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

//hooks 
import { useFetchData } from '../../hooks/useFetchData/useFetchData';
import { useShowMessages } from '../../hooks/useMessages/useMessages';
import { FilesHeader } from './filesHeader';
import { Link } from 'react-router-dom';
import CustomTableCell from '../shared/CustomTable/CustomTableCell';

let url = process.env.REACT_APP_API+ "/files";


export default function TableFiles(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState({
    title: '',
    file: '',
    category: '',
  });

  const { data : listFiles} = useFetchData(url + '/getFiles', {title: filter.title, file: filter.file, category: filter.category, page: page, rowsPerPage: rowsPerPage}, props.changed, true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    props.handleChanged();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    props.handleChanged();
  };

  const handlerEdit = (values) =>{
    props.setValues(values);
    props.setFile({});
    props.setEditing(true);
    props.setOpen(true);
  }

  function formatSize(size) {
    if (size < 1024) {
        return size + ' Bytes';
    } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
    } else if (size < 1024 * 1024 * 1024) {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
    } else {
        return (size / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    }
  }

  return (
    <Box sx={{ width: '100%', height: '100%'}}>
      <Paper elevation={3} sx={{ p: 1, display: 'flex',  mb: 2, border: '1px solid rgba(0, 0, 0, 0)', ':hover': { border: '1px solid' } }}>
        <FilesHeader values={filter} setValues={setFilter} handleChanged={props.handleChanged} categories={props.categories} />
      </Paper>
      <Paper >
        <TableContainer sx={{ overflow: 'scroll', height: '70vh'}} >
          <Table stickyHeader  sx={{ width: '100%' }} >
            <TableHead>
              <TableRow>
                  <CustomTableCell>Título</CustomTableCell>
                  <CustomTableCell>Categoria</CustomTableCell>
                  <CustomTableCell>Portado por</CustomTableCell>    
                  <CustomTableCell>Tamanho</CustomTableCell>    
                  <CustomTableCell align="center">Data</CustomTableCell>     
                  <CustomTableCell align='center'>Ações</CustomTableCell>                                              
              </TableRow>
            </TableHead>
            <TableBody>
            {listFiles && listFiles.map((row) => (
              <TableRow key={row.id} sx={{height: '25px'}}>
                <CustomTableCell component="th" scope="row">
                  {row.title}
                </CustomTableCell>
                <CustomTableCell align="left">{row.categoryName}</CustomTableCell>
                <CustomTableCell align="left">{row.nameUser}</CustomTableCell>
                <CustomTableCell align="left">{formatSize(row.size)}</CustomTableCell>
                <CustomTableCell align="center">{row.date}</CustomTableCell>
                <CustomTableCell align="center">
                  {/* <Button href={getLinkDownload(row.file_name, row.path)} target="_blank" variant="outlined" startIcon={<CloudDownloadIcon />} sx={{mr: 1}} color='success'>
                    Download
                  </Button> */}
                  <Button variant="outlined" startIcon={<VisibilityIcon />} onClick={() => handlerEdit(row)}>
                    Detalhes
                  </Button>
                </CustomTableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage='Registros por página'
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={(listFiles && listFiles) ? Math.ceil(listFiles[0]?.count) : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{fontSize: '12px'}}
        />
      </Paper>
    </Box>
  );
}